import React, { useRef } from 'react';
import AsyncSelect from 'react-select/async';
import { useLazyGetSearchQuery } from '../api/searchBarApiSlice';
import { useHistory } from 'react-router-dom';
import { COLORS } from './theme';
import Icon from './Icon';

function SearchItem(props) {
  const [search] = useLazyGetSearchQuery()
  const selectRef = useRef();
  const customStyles = {
    control: (provided, state) => {
      const focusedStyle = state.isFocused ? {
        color: COLORS.darkGrey,
        borderColor: COLORS.primary,
        outline: 0,
        boxShadow: `0 0 0 0.2rem ${COLORS.primary}50`,
        zIndex: 10000
      } : {}
      return ({
        borderColor: state.isDisabled ? "#ced4da" : "initial",
        ...provided,
        ...focusedStyle,
        "&:hover": {
          borderColor: null
        },
        backgroundColor: state.isDisabled ? "#e9ecef" : "white"
      })
    },
    singleValue: (provided, state) => ({
      color: state.isDisabled ? "#495057" : "inherit"
    }),
    menuPortal: (provided, state) => ({
      ...provided,
      zIndex: 10000
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? COLORS.primary : 'inherit',
      color: state.isSelected ? 'white' : (state.isDisabled ? '#AAAAAA' : 'inherit'),
      "&:hover": {
        backgroundColor: `${COLORS.primary}50`
      }
    }),
  }
  const loadOptions = ( inputValue, callback ) => {
    search(inputValue).then((response)=>{
      const options = response.data
      callback(options)
    })
  }
  const clearValue = () => {
    selectRef.current.select.select.clearValue()
  }
  const history = useHistory();
  const onChange = (e) => {
    if (e) {
      const path = e.value.replace(/^\/v1/, '')
      history.push(path)
      setTimeout(() => {
        //Timeout as the value is set again afterward
        clearValue()
      }, 100);
    }
  }

  const SearchOption = ({option}) => {
    if (option.os) {
      return (<>
        <Icon icon={option.os}/> {option.label}
      </>)
    } else {
      return (<>{option.label}</>)
    }
  }

  return (
    <>
      <AsyncSelect
        ref={selectRef}
        className="mx-2 my-auto d-inline w-100"
        loadOptions={loadOptions}
        placeholder="Search..."
        isClearable
        getOptionLabel={(option)=>(<SearchOption option={option} />)}
        onChange={onChange}
    		styles= {customStyles}
      >
      </AsyncSelect>
    </>
  )
}

export default SearchItem